import React from 'react';
import { img } from 'components/common';

const Header = () => {
  return (
    <header id="header" className="header">
      <div className="header__logo">
        {img('images/logo.png')}
      </div>
    </header>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/Header.js